export default [
  {
    path: '/workout-video-management',
    redirect: '/ads-video-management',
  },
  {
    path: '/workout-pending-videos',
    redirect: '/ads-management/pending',
  },
  {
    path: '/workout-MostWatched-videos',
    redirect: '/ads-management/most-click',
  },
  {
    path: '/workout-AllVideo-videos',
    redirect: '/ads-management/all',
  },
  {
    path: '/settings/workout',
    redirect: '/settings/content-library',
  },
  {
    path: '/settings/predesignworkout',
    redirect: '/settings/predefined-content',
  },
  {
    path: '/dashboard',
    name: 'my-poda-dashboard',
    component: () => import('@/features/dashboard/pages/dashboard.vue'),
  },
  {
    path: '/ads-video-management',
    name: 'ads-video-management',
    component: () => import('@/features/ads/pages/Ads_Management.vue'),
    meta: {
      HideHomeIcon:true,
      pageTitle: 'Ads Approval',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to:'/dashboard',
          class:"breadcrumb-slash"
        },
        {
          text: 'Ads Management',
          active: true,
        },
      ],
    },
  },
  {
    path: '/ads-management/pending',
    name: 'ads-pending',
    component: () => import('@/features/ads/pages/Ads_Pending.vue'),
    meta: {
      HideHomeIcon: true,
      pageTitle: 'Pending Ads',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Ads Management',
          to: '/ads-video-management',
        },
        {
          text: 'Pending Ads',
          active: true,
        },
      ],
    },
  },
  {
    path: '/ads-management/most-click',
    name: 'ads-most-click',
    component: () => import('@/features/ads/pages/Ads_Most_Click.vue'),
    meta: {
      HideHomeIcon: true,
      pageTitle: 'Most Clicks Ads',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Ads Management',
          to: '/ads-video-management',
        },
        {
          text: 'Most Clicks Ads',
          active: true,
        },
      ],
    },
  },
  {
    path: '/ads-management/uploaded',
    name: 'ads-uploaded',
    component: () => import('@/features/ads/pages/UploadedAds.vue'),
    meta: {
      HideHomeIcon: true,
      pageTitle: 'Uploaded Ads',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Ads Management',
          to: '/ads-video-management',
        },
        {
          text: 'Uploaded Ads',
          active: true,
        },
      ],
    },
  },
  {
    path: '/ads-management/detail/:id',
    name: 'ad-detail',
    component: () => import('@/features/ads/pages/Ad_Detail.vue'),
    meta: {
      HideHomeIcon: true,
      pageTitle: 'Ad Details',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Ads Management', to: '/ads-video-management' },
        { text: 'Ad Details', active: true },
      ],
    },
  },
  {
    path: '/ads-management/all',
    name: 'ads-all',
    component: () => import('@/features/ads/pages/Ads_All.vue'),
    meta: {
      HideHomeIcon: true,
      pageTitle: 'All Ads',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Ads Management',
          to: '/ads-video-management',
        },
        {
          text: 'All Ads',
          active: true,
        },
      ],
    },
  },
  {
    path: '/ads-pending-videos',
    name: 'ads-pending-videos',
    redirect: '/ads-management/pending',
  },
  {
    path: '/ads-most-watched-videos',
    name: 'ads-most-watched-videos',
    redirect: '/ads-management/most-click',
  },
  {
    path: '/ads-all-videos',
    name: 'ads-all-videos',
    redirect: '/ads-management/all',
  },
  {
    path: '/settings/allvideos',
    name: 'setting-AllVideo',
    component: () => import('@/features/settings/pages/Videos.vue'),
    meta: {
      HideHomeIcon:true,
      pageTitle: 'All Hide Videos',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to:'/dashboard'
        },
        {
          text: 'My Profile',
          to:'/admin/profile'
          
        },
        {
          text: 'Setting',
          to:'/admin/settings'
        },
        {
          text: 'Hide Videos',
          active:true
        },
      ],
    },
  },
  {
    path: '/settings/audio',
    name: 'setting-audio',
    component: () => import('@/features/settings/pages/audio/Audio.vue'),
    meta: {
      HideHomeIcon:true,
      pageTitle: 'Audio',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to:'/dashboard'
        },
        {
          text: 'My Profile',
          to:'/admin/profile'
          
        },
        {
          text: 'Setting',
          to:'/admin/settings'
        },
        {
          text: 'Audio',
          active:true
        },
      ],
    },
  },
  {
    path: '/setup',
    name: 'setup',
    component: () => import('@/features/settings/pages/Setup.vue'),
    meta: {
      HideHomeIcon: true,
      pageTitle: 'Setup',
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Setup', active: true },
      ],
    },
  },
  {
    path: '/setup/sql',
    name: 'setup-sql',
    component: () => import('@/features/settings/pages/SqlExplorer.vue'),
    meta: {
      HideHomeIcon: true,
      pageTitle: 'SQL queries',
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Setup', to: '/setup' },
        { text: 'SQL queries', active: true },
      ],
    },
  },
  {
    path: '/setup/request-logs',
    name: 'setup-request-logs',
    component: () => import('@/features/settings/pages/RequestLogs.vue'),
    meta: {
      HideHomeIcon: true,
      pageTitle: 'Mobile request logs',
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Setup', to: '/setup' },
        { text: 'Mobile request logs', active: true },
      ],
    },
  },
  {
    path: '/setup/storage-health',
    name: 'setup-storage-health',
    component: () => import('@/features/settings/pages/StorageHealth.vue'),
    meta: {
      HideHomeIcon: true,
      pageTitle: 'S3 health',
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Setup', to: '/setup' },
        { text: 'S3 health', active: true },
      ],
    },
  },
  {
    path: '/database-backup',
    name: 'database-backup',
    component: () => import('@/features/settings/pages/DatabaseBackup.vue'),
    meta: {
      HideHomeIcon: true,
      pageTitle: 'Database backup',
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Setup', to: '/setup' },
        { text: 'Database backup', active: true },
      ],
    },
  },
  {
    path: '/brands-management',
    name: 'brands-management',
    component: () => import('@/features/brands/pages/Brands.vue'),
    meta: {
      HideHomeIcon: true,
      pageTitle: 'Brands',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Brands', active: true },
      ],
    },
  },
  {
    path: '/categories-management',
    name: 'categories-management',
    component: () => import('@/features/settings/pages/Categories.vue'),
    meta: {
      HideHomeIcon: true,
      pageTitle: 'Categories',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Categories', active: true },
      ],
    },
  },
  {
    path: '/settings/categories',
    redirect: { name: 'categories-management' },
  },
  {
    path: '/music',
    name: 'setting-music',
    component: () => import('@/features/settings/pages/audio/Music.vue'),
    meta: {
      HideHomeIcon:true,
      pageTitle: 'Music',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to:'/dashboard'
        },
        {
          text: 'My Profile',
          to:'/profile'
          
        },
        {
          text: 'Music',
          active:true
        },
      ],
    },
  },
  {
    path: '/add-music',
    name: 'setting-add-audio',
    component: () => import('@/features/settings/pages/audio/AddMusic.vue'),
    meta: {
      HideHomeIcon:true,
      pageTitle: 'Music',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to:'/dashboard'
        },
        {
          text: 'My Profile',
          to:'/profile'
          
        },
        {
          text: 'Add-Music',
          active:true
        },
      ],
    },
  },
  {
    path: '/edit-music/:id',
    name: 'edit-music',
    component: () => import('@/features/settings/pages/audio/AddMusic.vue'),
    meta: {
      HideHomeIcon:true,
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to:'/dashboard'
        },
        {
          text: 'Music',
          to:'/music',
        },
        {
          text: 'Edit Music',
          active: true,
        },
      ],
    },
  },
  {
    path: '/notification',
    name: 'notification',
    component: () => import('@/features/notifications/pages/Notification.vue'),
    meta: {
      HideHomeIcon:true,
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to:'/dashboard'
        },
        {
          text: 'My Profile',
          to:'/Admin/profile'
        },
        {
          text: 'Notification',
          active: true,
        },
      ],
    },
  },
  {
    path: '/clientmanagement',
    name: 'clientmanagement',
    component: () => import('@/features/users/pages/Client_Management.vue'),
    meta: {
      HideHomeIcon:true,
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text:'Home',
          to:'/dashboard',
          class:'breadcrumb-slash'
        },
        {
          text: 'Mobile App Users',
          active:true,
          class: 'breadcrumb-slash'
        },
      ],
    },
  },
  {
    path: '/admin-users',
    name: 'admin-users-management',
    component: () => import('@/features/admin-users/pages/AdminUsersManagement.vue'),
    meta: {
      HideHomeIcon: true,
      pageTitle: 'Admin Users',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Admin Users', active: true },
      ],
    },
  },
  {
    path: '/clientmanagement/:id/followed-companies',
    name: 'user-followed-companies',
    component: () => import('@/features/users/pages/FollowedCompanies.vue'),
    meta: {
      HideHomeIcon: true,
      pageTitle: 'Followed Brands',
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Mobile App Users', to: '/clientmanagement' },
        { text: 'Followed Brands', active: true },
      ],
    },
  },
  {
    path: '/clientmanagement/:id/content-preferences',
    name: 'user-content-preferences',
    component: () => import('@/features/users/pages/ContentPreferences.vue'),
    meta: {
      HideHomeIcon: true,
      pageTitle: 'Content Preferences',
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Mobile App Users', to: '/clientmanagement' },
        { text: 'Content Preferences', active: true },
      ],
    },
  },
  {
    path: '/clientmanagement/:id/edit',
    name: 'client-edit',
    component: () => import('@/features/users/pages/User_Edit.vue'),
    meta: {
      HideHomeIcon: true,
      pageTitle: 'Edit User',
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Mobile App Users', to: '/clientmanagement' },
        { text: 'Edit User', active: true },
      ],
    },
  },
  {
    path: '/clientmanagement/:id',
    name: 'client-profile',
    component: () => import('@/features/users/pages/User_Profile_Activity.vue'),
    meta: {
      HideHomeIcon:true,
      pageTitle: 'Your Activity',
      breadcrumb: [
        {
          text:'Home',
          to:'/dashboard'
        },
        {
          text: 'Users Management',
          to:'/clientmanagement'
        },
        {
          text: 'Profile',
        },
        {
          text: 'Your Activity',
          active:true
        },
      ],
      showButtons: false,
    },
  },
  {
    path: '/trainermanagement',
    redirect: '/advertisers-management',
  },
  {
    path: '/trainermanagement/:id',
    redirect: to => ({ path: `/advertisers-management/${to.params.id}` }),
  },
  {
    path: '/trainermanagement/:id/followers',
    redirect: to => ({ path: `/advertisers-management/${to.params.id}/followers` }),
  },
  {
    path: '/advertisers-management',
    name: 'advertisers-management',
    component: () => import('@/features/advertisers/pages/Advertisers_Management.vue'),
    meta: {
      HideHomeIcon:true,
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to:'/dashboard'
        },
        {
          text: 'Advertisers Management',
          active:true
        },
      ],
    },
  },
  {
    path: '/advertisers-management/:id',
    name: 'advertiser-overall-details',
    component: () => import('@/features/advertisers/pages/Advertiser_Overall_Details.vue'),
    meta: {
      HideHomeIcon:true,
      pageTitle: 'Overall Details',
      breadcrumb: [
        {
          text:'Home',
          to:'/dashboard'
      },
        {
          text:'Advertisers Management',
          to:'/advertisers-management'
        },
        {
          text: 'Overall Details',
          active:true
        },
      ],
    },
  },
  {
    path: '/advertisers-management/:id/followers',
    name: 'advertiser-followers',
    component: () => import('@/features/advertisers/pages/Advertiser_Followers.vue'),
    meta: {
      HideHomeIcon:true,
      pageTitle: 'Followers',
      breadcrumb: [
        {
          text:'Home',
          to:'/dashboard'
        },
        {
          text:'Advertisers Management',
          to:'/advertisers-management'
        },
        {
          text: 'Followers',
          active:true
        },
      ],
    },
  },
  // {
  //   path: '/admin',
  //   name: 'admin',
  //   component: () => import('@/features/profile/pages/AdminProfile.vue'),
  //   meta: {
  //     HideHomeIcon:true,
  //     pageTitle: 'Admin Profile',
  //     breadcrumb: [
  //       {
  //         text: 'Home',
  //         to:'/dashboard'
  //       },
  //       {
  //         text: 'Profile',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/features/profile/pages/AdminProfile.vue'),
    meta: {
      HideHomeIcon:true,
      pageTitle: 'Admin Profile',
      breadcrumb: [
        {
          text: 'Home',
          to:'/dashboard'
        },
        {
          text: 'Profile',
          active: true,
        },
      ],
    },
  },
  {
    path: '/cms',
    name: 'cms',
    component: () => import('@/features/cms/pages/CmsEditor.vue'),
    meta: {
      HideHomeIcon:true,
      pageTitle: 'CMS',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to:'/dashboard'
        },
        {
          text: 'CMS',
          active: true,
        },
      ],
    },
  },
  {
    path: '/cms/addcms',
    name: 'add-cms',
    component: () => import('@/features/cms/pages/AddCms.vue'),
    meta: {
      HideHomeIcon:true,
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to:'/dashboard'
        },
        {
          text: 'CMS',
          to:'/cms',
        },
        {
          text: 'Add CMS',
          active: true,
        },
      ],
    },
  },
  {
    path: '/cms/editcms/:id',
    name: 'edit-cms',
    component: () => import('@/features/cms/pages/AddCms.vue'),
    meta: {
      HideHomeIcon:true,
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'Home',
          to:'/dashboard'
        },
        {
          text: 'CMS',
          to:'/cms',
        },
        {
          text: 'Edit CMS',
          active: true,
        },
      ],
    },
  }
  // {
  //   path: '/apps/e-commerce/:slug',
  //   name: 'apps-e-commerce-product-details',
  //   component: () => import('@/views/apps/e-commerce/e-commerce-product-details/ECommerceProductDetails.vue'),
  //   meta: {
  //     pageTitle: 'Product Details',
  //     contentClass: 'ecommerce-application',
  //     breadcrumb: [
  //       {
  //         text: 'ECommerce',
  //       },
  //       {
  //         text: 'Shop',
  //         active: true,
  //       },
  //       {
  //         text: 'Product Details',
  //         active: true,
  //       },
  //     ],
  //   },
  // },

]
